<h1 mat-dialog-title i18n>
	<ng-container *ngIf="dialogData.mode === 'create'">Create Required Version</ng-container>
	<ng-container *ngIf="dialogData.mode === 'edit'">Edit Required Version</ng-container>
	<small class="align-top">- {{dialogData.appKey.name}} ({{dialogData.platform}})</small>
</h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content px-3">
		<div class="row">
			<mat-form-field appearance="standard" class="col-12 col-md-6">
				<mat-label i18n>Action</mat-label>
				<mat-select formControlName="action">
					<mat-option *ngFor="let action of actions" [value]="action">
						{{action}}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-md-6">
				<mat-label i18n>Version</mat-label>
				<input matInput type="text" formControlName="version" placeholder="e.g. 1.2.3" i18n-placeholder/>
				<mat-error *ngIf="formInputs.get('version').hasError('required')" i18n>Version is required</mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-md-6">
				<mat-label i18n>Build Number</mat-label>
				<input matInput type="number" formControlName="buildNumber" i18n-placeholder/>
				<mat-error *ngIf="formInputs.get('buildNumber').hasError('required')" i18n>Build number is required</mat-error>
				<mat-error *ngIf="formInputs.get('buildNumber').hasError('min')" i18n>Build number must be 0 or greater</mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-md-6">
				<mat-label i18n>Min OS Version</mat-label>
				<input matInput type="text" formControlName="minOSVersion" placeholder="e.g. 10.0" i18n-placeholder/>
				<mat-error *ngIf="formInputs.get('minOSVersion').hasError('required')" i18n>Min OS Version is required</mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-md-6">
				<mat-label i18n>Released Date</mat-label>
				<input matInput type="date" formControlName="releasedAt" i18n-placeholder/>
				<mat-error *ngIf="formInputs.get('releasedAt').hasError('required')" i18n>Released date is required</mat-error>
			</mat-form-field>
		</div>
	</div>

	<div mat-dialog-actions class="row px-1 mb-0 justify-content-center">
		<div class="col-6 text-center">
			<button class="w-100" type="submit" [disabled]="!formInputs.valid" mat-flat-button color="primary" i18n>Save</button>
		</div>
		<div class="col-6 text-center">
			<button class="w-100" type="button" (click)="close()" mat-stroked-button i18n>Cancel</button>
		</div>
	</div>
</form>

